import {UxConfig} from "../uxConfig/uxConfig";

export class UxConfigAsMap extends UxConfig {
    urlRoot() {
        return '/deviceFeatureSets/uxConfigAsMap';
    }
}